export const LonelyParentVariant = [
	{
		value: '9',
		name: 'Ne',
	},
	{
		value: '16',
		name: 'Ano',
	},
];
